import { createFileRoute } from "@tanstack/react-router";
import AdminSigningPage from "@/admin/pages/signing";

export const Route = createFileRoute("/admin/signing/")({
  component: AdminSigningPage,
});
